import { getTechTestData, getAssessmentTestData, UploadStyle, CustomToastrAction, UploadIcon, PageStyle, cursorNone, Button, ButtonStyle, CommonAction, MANAGE_ASSESSMENT, TRANSLATION} from '@/imports-files/pages/clients/jobs/automations';


export class TechTestAction
{
  constructor(setTests)
  {
    this.setTests  =  setTests
    this.customToastrAction  =  new CustomToastrAction(); 
    this.commonAction = new CommonAction();
  }

  getSuggestionValue(suggestion) {
    return suggestion.code;
  }

  renderSuggestion(suggestion) {
    return (
      suggestion.id == 'upload_new_test' 
      ? <span className={`${UploadStyle.uploadNewTest}`}><UploadIcon/> {suggestion.name}</span>
      : <span>{suggestion.name}</span>
    );
  }

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async getIkmTests(value) {
    const escapedValue = this.escapeRegexCharacters(value.value.trim());
    if (escapedValue === '') {
      return [];
    }
    let techTests = await getTechTestData(escapedValue)
    return techTests
  }

  async getAssessments(value, isCustom, t) {
    const escapedValue = this.escapeRegexCharacters(value.value.trim());
    let techTests = await getAssessmentTestData(escapedValue, isCustom, t)
    return techTests
  }
  
  async onSuggestionsFetchRequested(value, techTestAction, test_type, isCustom, t){
    test_type = test_type || 'TestLibrary'
    if(test_type == 'TestLibrary'){
      let techTests = await techTestAction.getIkmTests(value)
      this.setTests(techTests)
    }
    else if(test_type == 'Assessment'){
      let techTests = await techTestAction.getAssessments(value, isCustom, t)
      this.setTests(techTests)
    }
    
  };

  renderInputComponent = inputProps => (
      <input className = {PageStyle.Form__Input} autoComplete={"password"}
      {...inputProps}  style={inputProps.styleError}/>
  );

  shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@\.]+$/.test(email);
  }

  renderMemberInputComponent = inputProps => (
    <div className="buttonIn AutoSuggestInput__Tags">
        {inputProps.selectedValues?.map((item, itemIndex) => (
          <div className={PageStyle.SetupPopup__Tags} key={`interview_email_${itemIndex}`}>
            {item.name ? (<span>{item.name}</span>) : (<span>{item.email}</span>)}
            {inputProps.editable && (<button
              ButtonStyle={`${ButtonStyle.nobgbutton}`}
              type="button"
              onClick={() =>
                inputProps.techTestAction.handleDelete(
                  inputProps.formik,
                  inputProps.itemIndex,
                )
              }
            > {inputProps.closeIcon}
            </button>)}
          </div>
        ))}
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      {inputProps.add_button && <Button buttonstyle={`${ButtonStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`} disabled={inputProps.disabled} onClick={(event) => inputProps.techTestAction.onAddClick(event, inputProps)}>{TRANSLATION('button:add:default')}</Button>}
    </div>
  );

  onSuggestionSelection(old_ids, id, old_initials, new_initial){
    if(!(old_ids.includes(id) || old_ids.includes(id.toString())))
     {
      old_ids.unshift(id)
      old_initials.unshift(new_initial)
     } 
  }

  onAddClick = (event, params) => {
    let email = params.value 
    if(this.isEmail(email)){
      params.techTestAction.onSuggestionSelection(params.formik.values.job_test_detail_attributes.member_emails, email, params.formik.values.job_test_detail_attributes.member_initials, {email: email, name_initials: null, name: null })
      params.setStageEmail({value: '', error: ''})
    }
    else{
      params.setStageEmail({value: email, error: 'Please enter valid email'})
    }
  }

  handleKeyDown(event, formik, setStageEmail){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value 
      if(this.isEmail(email)){
        this.onSuggestionSelection(formik.values.job_test_detail_attributes.member_emails, email, formik.values.job_test_detail_attributes.member_initials, {email: email, name_initials: null, name: null })
        setStageEmail({value: '', error: ''})
      }
      else{
        setStageEmail({value: email, error: 'Please enter valid email'})
      }
    }
  }

  handleDelete(formik, itemIndex){
    let member_emails = formik.values.job_test_detail_attributes.member_emails
    let member_initials = formik.values.job_test_detail_attributes.member_initials
    member_emails.splice(itemIndex, 1)
    member_initials.splice(itemIndex, 1)
    formik.setFieldValue(`job_test_detail_attributes.member_emails`, [...member_emails])
    formik.setFieldValue(`job_test_detail_attributes.member_initials`, [...member_initials])
  };

  async onOptionChange(formik, event, setTechTest, validationData, setvalidationData, test_origin){
    if(test_origin == 'custom')
    {
      await formik.setFieldValue('test_type', event.target.value)
      formik.setFieldValue('test_id', '')
    }
    else
    {
      await formik.setFieldValue('job_test_detail_attributes.test_type', event.target.value)
      formik.setFieldValue('job_test_detail_attributes.test_id', '')
    }
    validationData.type = event.target.value
    validationData.test_id = ''
    setvalidationData(validationData)
    setTechTest('');
  }

  async onTestoptionChange(formik, event){
    let val = event.target.value
    if(val == 'file') {
      await formik.setFieldValue(event.target.name, val)
      await formik.setFieldValue(event.target.name.replace('file_type', 'link'), '')
    }
    else{
      await formik.setFieldValue(event.target.name, val)
      await formik.setFieldValue(event.target.name.replace('file_type', 'file'), '')
      await formik.setFieldValue(event.target.name.replace('file_type', 'filename'), '')
    }
  }

  async uploadFile(formik, files, event){
    const file = files[0]
    const name_atr = event.target?.name || event.currentTarget.getAttribute('name')
    if(file)
    {  formik.setFieldValue(name_atr.replace('file', 'file_type'), 'file')
      if(file.size > MANAGE_ASSESSMENT.file_size){
        await formik.setFieldValue(name_atr.replace('file', 'filename'), file.name)
        await formik.setFieldValue(name_atr.replace('file', 'file'), '')
        await formik.setFieldValue(name_atr.replace('file', 'filesize'), file.size)
      }
      else{
        const base64 = await this.commonAction.convertToBase64(file);
        await formik.setFieldValue(name_atr.replace('file', 'filename'), file.name)
        await formik.setFieldValue(name_atr.replace('file', 'file'), base64)
        await formik.setFieldValue(name_atr.replace('file', 'filesize'), file.size)
      }
    }
  }

  async onRemoveFile(formik, name){
    await formik.setFieldValue(name.replace('file', 'file_type'), 'link')
    await formik.setFieldValue(name.replace('file', 'file'), '')
    await formik.setFieldValue(name.replace('file', 'filename'), '')
  }


  async setCustomTestOptions(formik, suggestionId, validationData, setvalidationData){
    if(suggestionId == 'upload_new_test'){
      validationData.test_id = suggestionId
      document.getElementsByClassName("asessment-form-section")[0]?.classList?.remove('displaynone')
    }
    else{
      validationData.test_id = suggestionId
      document.getElementsByClassName("asessment-form-section")[0]?.classList?.add('displaynone')
    }
    setvalidationData(validationData)
  }

  setJobTestDetail(job_test_detail_attributes, t){
    let value = job_test_detail_attributes
    if((job_test_detail_attributes.test_type == 'Assessment') && (job_test_detail_attributes.entity_type == 'JobStage')) 
      {
        value.test_id = 'upload_new_test' 
        value.test_name = t('modal:automation:upload_new_test')
      }
    if(!value.assessment) value.assessment =  {
      name: '',
      file_type: 'link',
      link: '',
      file: '',
      filename: '',
      filesize: '',
    }
    return value
  }

}